import { render, staticRenderFns } from "./addDividend.vue?vue&type=template&id=0730720d&scoped=true&"
import script from "./addDividend.vue?vue&type=script&lang=js&"
export * from "./addDividend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0730720d",
  null
  
)

export default component.exports